<template>
  <form class="search-option d-flex flex-column justify-content-between flex-nowrap align-item-stretch" id="facette">
    <div class="row header-search-option" :class="{ 'hidden-sm': !displayMobile, hidden: displayMobile }">
      <span class="title-level level-3 mb-3 w-100" role="heading" :aria-level="titleLevel">
        <i class="fa fa-filter" aria-hidden="true"></i>
        &nbsp;{{ i18n.filter }}
      </span>
      <p class="sr-only">{{ i18n.resultsUpdate }}</p>
      <button
        class="btn btn-light btn-block hidden-sm"
        type="reset"
        @click="onResetClick"
        :disabled="isResetDisabled"
        :aria-disabled="isResetDisabled"
      >
        <i class="fa fa-refresh" aria-hidden="true"></i>
        &nbsp;{{ i18n.resetFilters }}
      </button>
    </div>
    <div class="row flex-grow-1 content-search-option flex-column flex-nowrap">
      <categorie
        v-for="categorie in categories"
        :key="categorie"
        :categorieId="categorie"
        :opened="isCategoryOpen(categorie)"
        @toggle-clicked="categoryDisplayToggle(categorie)"
        ref="categorieChildren"
      />
    </div>
    <div class="row footer-search-option" :class="{ 'hidden-sm': !displayMobile, hidden: displayMobile }">
      <button
        class="btn btn-light btn-block"
        type="reset"
        @click="onResetClick"
        :disabled="isResetDisabled"
        :aria-disabled="isResetDisabled"
      >
        <i class="fa fa-refresh" aria-hidden="true"></i>
        &nbsp;{{ i18n.resetFilters }}
      </button>
    </div>

    <div class="container-fluid">
      <div class="row justify-content-between footer-search-option" v-if="displayMobile">
        <button
          class="btn btn-light col-7"
          type="reset"
          @click="onResetClick"
          :disabled="isResetDisabled"
          :aria-disabled="isResetDisabled"
        >
          <i class="fa fa-refresh" aria-hidden="true"></i>
          &nbsp;{{ i18n.resetFilters }}
        </button>
        <button
          v-if="showSearchButton"
          class="btn btn-primary search-button col-4"
          @click="searchButtonClicked"
          type="button"
        >
          <span class="badge">
            {{ totalRows }}
            <span class="sr-only">{{ i18n.resultsFound }}</span>
          </span>
          &nbsp;{{ i18n.seeResults }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import Categorie from '@/components/categorie/Categorie.vue';
import { titleLevelHelper } from '@/helpers/index.js';

export default {
  components: {
    Categorie,
  },
  props: {
    // Multiple categories can be open at the same time
    multi: {
      type: Boolean,
      default: true,
    },
    showSearchButton: {
      type: Boolean,
      default: false,
    },
    // Handle mobile display
    displayMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // keeping the categories that aren't hidden
    categories() {
      return this.$store.state.categories.filter((category) => this.$route.query[`${category}Hidden`] !== 'true');
    },
    isResetDisabled() {
      return this.$store.getters.getCheckedFacets.length === 0;
    },
    totalRows() {
      return this.$store.state.total;
    },
  },
  methods: {
    /**
     * Reset all filters
     */
    onResetClick() {
      this.$store.dispatch('resetFacets');
      (this.$refs.categorieChildren || []).forEach((categorie) => {
        categorie.resetFilter();
      });
    },
    /**
     * Handle category toggle, if multi is set to false only one category can be open
     */
    categoryDisplayToggle(category) {
      this.$set(this.openedCategories, category, !this.openedCategories[category]);
      if (!this.multi) {
        // Close all others categories
        // Close toggled category if already opened
        for (const cat of Object.keys(this.openedCategories)) {
          this.$set(this.openedCategories, cat, cat === category && this.openedCategories[category]);
        }
      }
    },
    /**
     * Check if a category is open
     */
    isCategoryOpen(category) {
      if (this.openedCategories[category] === undefined) {
        // each category is open by default if possible, only the first otherwise
        const openedByDefault = this.multi || this.categories.indexOf(category) === 0;
        this.$set(this.openedCategories, category, openedByDefault);
      }
      return this.openedCategories[category];
    },
    searchButtonClicked() {
      this.$emit('searchButtonClicked');
    },
  },
  data: function() {
    return {
      openedCategories: {},
      // Calculate translation to simplify HTML binding
      i18n: {
        filter: this.$t(`filter`),
        resultsUpdate: this.$t(`resultsUpdate`),
        resetFilters: this.$t(`resetFilters`),
        resultsFound: this.$t('resultsFound'),
        seeResults: this.$t('seeResults'),
      },
      titleLevel: titleLevelHelper.computeTitleLevel(2),
    };
  },
};
</script>

<style lang="less">
@import 'list-categorie.less';
</style>
